import { formatUnitValue } from "../unitWiseCostFilterOptions";
// const COLORS = [
//     "#2563EB",
//     "#10B981",
//     "#F59E0B",
//     "#8B5CF6",
//     "#F43F5E",
//     "#06B6D4",
//     "#6366F1",
//     "#14B8A6",
//     "#F97316",
//     "#A855F7",
//     "#EC4899",
//     "#84CC16",
// ];

export const unitWiseCostCenterTextPlugin = (valueMode) => ({
    id: "unitWiseCostCenterText",

    afterDraw(chart) {
        const { ctx } = chart;

        const dataset = chart.data.datasets?.[0];

        if (!dataset) return;

        const value =
            Number(dataset.overallValue) || 0;

        // Get actual doughnut center from ArcElement
        const meta = chart.getDatasetMeta(0);
        const firstArc = meta?.data?.[0];

        if (!firstArc) return;

        const centerX = firstArc.x;
        const centerY = firstArc.y;

        ctx.save();

        // VALUE
        ctx.font = "700 22px Arial";
        ctx.fillStyle = "#101828";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";

        ctx.fillText(
            formatUnitValue(value, valueMode),
            centerX,
            centerY - 8
        );

        // LABEL
        ctx.font = "500 11px Arial";
        ctx.fillStyle = "#667085";

        ctx.fillText(
            dataset.centerLabel || "Overall",
            centerX,
            centerY + 16
        );

        ctx.restore();
    },
});

export const generateUnitColors = (count) => {

    if (!count) return [];

    // Single-hue blue gradient - callers always pass value-sorted data, so
    // index 0 (highest share) gets the darkest shade and the last index
    // (lowest share) gets the lightest, matching the "Cost Share" legend
    // convention used elsewhere in the app.
    const HUE = 221;
    const SATURATION = 83;
    const LIGHTNESS_START = 30;
    const LIGHTNESS_END = 88;

    if (count === 1) {
        return [`hsl(${HUE}, ${SATURATION}%, ${LIGHTNESS_START}%)`];
    }

    return Array.from(
        { length: count },
        (_, index) => {

            const lightness =
                LIGHTNESS_START +
                (index * (LIGHTNESS_END - LIGHTNESS_START)) / (count - 1);

            return `hsl(${HUE}, ${SATURATION}%, ${lightness}%)`;
        }
    );
};


export const getUnitWiseCostDoughnutData = (
    sortedUnitData = [],
    overallValue = 0,
    centerLabel
) => {

    const colors = generateUnitColors(
        sortedUnitData.length
    );

    return {
        labels: sortedUnitData.map(
            (item) => item.unitName
        ),

        datasets: [
            {
                data: sortedUnitData.map(
                    (item) => item.value
                ),

                backgroundColor: colors,

                borderColor: "#FFFFFF",
                borderWidth: 2,

                hoverOffset: 5,

                spacing: 2,
                // Custom value for centre plugin
                overallValue,
                centerLabel,
            },
        ],
    };
};

export const getUnitWiseCostDoughnutOptions = (valueMode) => ({
    responsive: true,
    maintainAspectRatio: false,

    cutout: "68%",

    plugins: {
        // legend: {
        //     display: true,

        //     position: "right",

        //     labels: {
        //         usePointStyle: true,
        //         pointStyle: "circle",

        //         boxWidth: 8,
        //         boxHeight: 8,

        //         padding: 18,

        //         font: {
        //             size: 12,
        //         },

        //         generateLabels: (chart) => {
        //             const dataset =
        //                 chart.data.datasets[0];

        //             return chart.data.labels.map(
        //                 (label, index) => ({
        //                     text: `${label}  ${Number(
        //                         dataset.data[index]
        //                     ).toFixed(2)}%`,

        //                     fillStyle:
        //                         dataset.backgroundColor[index],

        //                     strokeStyle:
        //                         dataset.backgroundColor[index],

        //                     pointStyle: "circle",

        //                     hidden: false,

        //                     index,
        //                 })
        //             );
        //         },
        //     },

        //     onClick: () => {},
        // },

        legend: {
            display: false,
        },
        tooltip: {
            callbacks: {
                label: (context) => {
                    const value = Number(context.raw) || 0;
                    return ` ${context.label}: ${formatUnitValue(value, valueMode)}`;
                },
            },
        },
        // chartjs-plugin-datalabels is registered globally (see BarChart.jsx/
        // StackedBarLineChart.jsx) so it applies to every chart by default -
        // this chart only wants values on hover (tooltip) and in the side
        // cards, not printed on the arcs themselves.
        datalabels: {
            display: false,
        },
    },
});

